import { useSyncExternalStore } from "react";

export function useMedia(query: string, fallback = false) {
  return useSyncExternalStore(
    (notify) => {
      const m = window.matchMedia(query);
      m.addEventListener("change", notify);
      return () => m.removeEventListener("change", notify);
    },
    () => window.matchMedia(query).matches,
    () => fallback,
  );
}

export const useDesktop = () => useMedia("(min-width: 768px)");
